export default __webpack_public_path__ + "static/media/08-make more money.b02b75c7.svg";